module.exports = __webpack_public_path__ + "img/IMG_3945_L_Foamcore.1c99e43b.jpg";